import React, { useState, Fragment, useEffect } from 'react';
import {
    Card,
    CardBody,
    Button, Input,
    Row, Label
} from 'reactstrap';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';

export default function MessengerRestricted({ botSettings, saveIntegration }) {
    const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(botSettings?.urlRestrictions !== null &&
        !botSettings?.urlRestrictions?.disabled
    );


    const [inputData, setInputData] = useState({
        disabled: true,
        pageLinks: ""
    });
    useEffect(() => {
        if (botSettings !== undefined && botSettings.urlRestrictions !== null) {
            setInputData({
                ...botSettings.urlRestrictions,
                disabled: botSettings.urlRestrictions.disabled,
                pageLinks: botSettings.urlRestrictions.pageLinks !== null ? botSettings.urlRestrictions.pageLinks : ""

            });
        }
    }, [botSettings]);

    const handleChange = (e) => {
        setInputData({
            ...inputData,
            pageLinks: e.target.value
        });
    }

    const handleSwitchChange = (value) => {
        setCheckedPrimarySmall(value);
        setInputData({
            ...inputData,
            disabled: !value
        });
    };
    // const handleSave = () => {
    //     let correctedPageLinks = inputData.pageLinks
    //         .split(',')
    //         .map(url => url.trim())
    //         .filter(url => url !== "")
    //         .map(url => {
    //             url = url.replace(/\/+$/, '').toLowerCase();
    //             return url;
    //         })
    //         .join(',');


    //     let setting = { ...botSettings };
    //     setting.urlRestrictions = {
    //         ...inputData,
    //         pageLinks: correctedPageLinks,
    //     };

    //     saveIntegration({
    //         botSetting: setting,
    //     });
    // };
    const handleSave = () => {
        const defaultTrustedUrls = [
            "https://preview.concierge.synxis.com",
            "https://www.myma.ai"
        ];


        let normalizedInput = inputData.pageLinks
            .replace(/[\n;]/g, ',') // Replace line breaks and semicolons with commas
            .split(',')
            .map(url => url.trim()) // Trim whitespace
            .filter(url => url !== "") // Remove empty entries
            .map(url => url.replace(/\/+$/, '').toLowerCase()); // Remove trailing slashes and convert to lowercase

        // Add default trusted URLs if not already included
        defaultTrustedUrls.forEach(defaultUrl => {
            if (!normalizedInput.includes(defaultUrl)) {
                normalizedInput.push(defaultUrl);
            }
        });

        let correctedPageLinks = normalizedInput.join(',');

        let setting = { ...botSettings };
        setting.urlRestrictions = {
            ...inputData,
            pageLinks: correctedPageLinks,
        };

        saveIntegration({
            botSetting: setting,
        });
    };
    //     let setting = botSettings;
    //     setting.urlRestrictions = inputData;
    //     saveIntegration({
    //         botSetting: setting
    //     });
    // };
    return (
        <Card className="mb-4">
            <CardBody>
                <div className="text-center">
                    <h6>Keep your Messenger Secure</h6>
                </div>
                <Separator className="mb-3" />
                <Row>
                    <Colxx md={12} className='mt-2'>
                        <div className="d-flex w-100">
                            <Label>Enable URL Restriction</Label>
                            <Switch
                                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                                checked={checkedPrimarySmall}
                                onChange={(primary) => handleSwitchChange(primary)}
                            />
                        </div>
                    </Colxx>
                    <Colxx md={12} className='mt-2'>
                        <Label>List your trusted pages <br /> Your Messenger will only show on these pages.</Label>
                        <div className="mb-2">
                            <Input
                                type="textarea"
                                value={inputData.pageLinks}
                                onChange={(e) => handleChange(e)}
                                name="urls"
                                style={{ height: "100px" }}
                            />
                        </div>
                        <p>To mark specific pages to show the Chatbot on list your trusted page, separated by commas.</p>
                    </Colxx>
                    <Separator className="mb-3 mt-4" />
                    <Colxx md={12} className="mt-2 text-center">
                        <div className="mb-1 mt-4 ml-2">
                            <Button
                                color="primary"
                                size="xs"
                                className="mt-1"
                                onClick={() => handleSave()}
                            >
                                Save
                            </Button>
                        </div>
                    </Colxx>
                </Row>
            </CardBody>
        </Card>
    );

}